"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaAlert = exports.MediaAlerts = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaItem_1 = require("../MediaItem");
var MediaContext_1 = require("../MediaContext");
function MediaAlerts(_a) {
    var onCancel = _a.onCancel, mediaItem = _a.mediaItem;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    if ((0, MediaItem_1.isUploadingMediaItem)(mediaItem))
        return null;
    if (mediaItem.filter_state === false) {
        return (React.createElement(MediaAlert, { status: "error", onClose: onCancel },
            React.createElement(react_1.AlertTitle, null, _js("Can't place %1 here.", mediaItem.filename))));
    }
    return null;
}
exports.MediaAlerts = MediaAlerts;
function MediaAlert(_a) {
    var children = _a.children, onClose = _a.onClose, props = __rest(_a, ["children", "onClose"]);
    return (React.createElement(react_1.Box, { mb: 4, ml: 6, mr: 6 },
        React.createElement(react_1.Alert, __assign({ p: 2, flex: 1, borderRadius: "md", justifyContent: "space-between" }, props),
            React.createElement(react_1.Flex, { gap: 1, direction: "column" }, children),
            React.createElement(react_1.CloseButton, { alignSelf: "flex-start", position: "relative", right: -1, top: -1, onClick: onClose }))));
}
exports.MediaAlert = MediaAlert;
